// extracted by mini-css-extract-plugin
export default {"container":"Dashboard-module--container--WC0Dy","cards":"Dashboard-module--cards--nNwDj","cardsmobile":"Dashboard-module--cardsmobile--b82co"};